import React from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import PropTypes from 'prop-types'
import * as ReactSelect from 'react-select'
import AsyncSelect from 'react-select/async'
import { format } from 'date-fns'
import { InputMask as ReactInputMask } from '@react-input/mask'


export const guid = () =>
	'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = Math.random() * 16 | 0;
		const v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});

export const simpleHash = (value) => {
	if (!value || value.length === 0) {
		return 0;
	}
	let hash = 0;

	for (const char of value) {
		hash = ((hash << 5) - hash) + char.charCodeAt(0);
		hash &= hash;
	}
	return hash.toString(16);
};

export const PageHeader = {
	Subtitle: (title, level = 1) => {
		const el = document.getElementById('subtitle' + level);

		if (el) {
			el.innerHTML = title ? ` - ${title}` : '';
		}
	}
}


const extend = window.extend = (target, source) => {
	if (typeof target !== 'object') {
		target = source instanceof Array ? [] : {};
	}
	for (let key in source) {
		if (source.hasOwnProperty(key)) {
			let value = source[key];

			if (value instanceof Array) {
				target[key] = extend([], value);
			}
			else if (value instanceof Object && value.constructor === Object) {
				target[key] = extend({}, value);
			}
			else {
				target[key] = value;
			}
		}
	}
	//for (var a = 2, l = arguments.length; a < l; a++) {
	//	extend(target, arguments[a]);
	//}
	return target;
}

Date.prototype.toISO = function () {
	let month = String(this.getMonth() + 1).padStart(2, '0');
	let day = String(this.getDate()).padStart(2, '0');
	let hour = String(this.getHours()).padStart(2, '0');
	let min = String(this.getMinutes()).padStart(2, '0');

	return `${this.getFullYear()}-${month}-${day}T${hour}:${min}`
}

export class Loader extends React.Component {
	render() {
		const loader = <div key='l' className={classNames("loading", this.props.className || null)}><div /></div>;

		if (!this.props.dimmed) {
			return loader;
		}
		return [
			loader,
			<div key='c' className='ui-widget-overlay' style={{
				position: "fixed", zIndex: 99999,
				top: 0, left: 0, right: 0, bottom: 0,
				width: '100%', height: '100%', minHeight: '100%',
				background: 'rgba(60, 50, 80, 0.30)'
			}} />
		];
	}
}

export class Component extends React.Component {
	constructor(props, lng_files = null) {
		super(props);
		this.lng_files = lng_files;
		this.state = { loading: lng_files !== null };
		/*
				if (lng_files) {
					this.state = { loading: true };
					trans.load(lng_files, () => {
						//this.setState({ loading: false });
						this.state.loading = false;
					});
				}
				else {
					this.state = { loading: false };
				}
		*/
	}

	setLoading(start, now) {
		if (now) {
			this.setState({ loading: start });
		}
		else {
			this.state.loading = start;
		}
	}
	startLoading(now = true) { this.setLoading(true, now); }
	stopLoading(now = true) { this.setLoading(false, now); }
	getLoader() {
		return this.state.loading || this.state.saving ? <Loader className='inline' /> : null;
	}

	componentDidMount() {
		if (this.lng_files) {
			trans.load(this.lng_files, () => {
				this.setState({ loading: false });
			});
			this.lng_files = null;
		}
	}

	renderElement() {
		return 'not implemented yet!';
	}

	render() {
		if (this.state.loading) {
			return <Loader className='inline' />;
		}
		return this.renderElement();
	}
}

Component.propTypes = {
	loading: PropTypes.bool
}

export class Button extends React.Component {
	constructor(props) {
		super(props);
		this.state = { icon: props.icon ? (props.icon.indexOf(' ') > 0 ? props.icon : `la la-${props.icon}`) : null };
	}

	style = () => 'btn' + (this.props.className ? ` ${this.props.className}` : '')

	onClick = () => { }

	static getDerivedStateFromProps = (props, state) =>
		props.icon
			? { icon: (props.icon.indexOf(' ') > 0 ? props.icon : `la la-${props.icon}`) }
			: null;

	render() {
		let children = this.props.children || [
			this.state.icon
				? <em key='1' className={this.state.icon} />
				: null,
			this.props.label ? <span key='2'>{this.props.label}</span> : null
		];
		return (
			<button
				type={this.props.type || 'button'}
				className={this.style()}
				disabled={this.props.disabled || false}
				onClick={this.props.onClick || this.onClick}
				title={this.props.title || null}
			>
				{children}
			</button>
		);
	}
}

export class ButtonDelete extends Button {
	style() {
		return 'btn btn-danger ' + (this.props.className || '');
	}
}
ButtonDelete.defaultProps = {
	icon: 'trash'
}

export class Badge extends React.Component {
	render() {
		const { title, className, tip, children } = this.props;
		return <div className={`badge ${className}`} title={tip || null}>{title || children}</div>;
	}
}

export class ButtonAttachment extends Button {
	constructor(props) {
		super(props);
		this.name = props.name || guid();
		this.state = {};
	}

	onUploadChange = (e) => {
		if (e.target.files.length == 0) {
			return;
		}
		if (this.props.model && this.props.name) {
			this.props.model[this.props.name] = e.target.files[0];
		}
		this.setState({ file: e.target.files[0] });
	}

	onClear = () => {
		if (this.props.model && this.props.name) {
			this.props.model[this.props.name] = null;
		}
		this.setState({ file: null });
	}

	render() {
		let _file = !this.state.file ? null : <span> ({this.state.file.name})</span>;
		let el_remove = !this.state.file
			? null
			: <button key="2" className="btn btn-default" title="Remover anexo" onClick={this.onClear}><em className="fa fa-times"></em></button>
		let el = [
			<label key="1" htmlFor={this.name} className="btn btn-default">
				<em className="fa fa-papperclip" />
				<span>{__('attrs_attachment') + ' ...'}</span>{_file}
				<input type="file" id={this.name} onChange={this.onUploadChange} style={{ display: "none" }} />
			</label>,
			el_remove
		];
		return el;
	}
}

export function CheckToggleButton(props = {}) {
	const [hovered, setHovered] = React.useState(false)
	const toggleHover = () => setHovered(!hovered)
	const _props = Object.assign({}, props, {
		className: hovered ? (props.classNameHovered || props.className || 'btn btn-default') : (props.className || 'btn btn-default')
	})

	return (
		<button {..._props} onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
			<em className={hovered ? (props.iconHovered || 'la la-check') : (props.icon || 'la la-times')} />
		</button>
	)
}

export class LinkBack extends React.Component {
	onGoBack = () => {
		window.history.back();
	}

	render() {
		return (
			<a onClick={this.onGoBack} className="go-back btn btn-light btn-circular">
				<em className="la la-arrow-left" />
			</a>
		);
	}
}

export class TextComponent extends Component {
	getValue() {
		const value = this.props.model && this.props.name ? this.props.model[this.props.name] : this.props.value;
		return value || (value === 0 ? value : '');
	}

	renderElement() {
		return this.props.renderElement instanceof Function ? this.props.renderElement() : null;
	}

	renderTip() {
		if (!this.props.tip || this.tipped) {
			return null
		}
		this.tipped = true
		const tip =
			<span className='tip'>
				<em className='la la-info-circle' />
				<span>{this.props.tip}</span>
			</span>
		if (this.props.inlineTip) {
			return tip
		}
		return (
			<div>
				<div className="clearfix" />
				{tip}
			</div>
		)
	}

	render() {
		this.tipped = false
		let el = this.renderElement();

		if (this.props.icon) {
			el = <div title={this.props.label || this.props.placeholder}>
				<em className={this.props.icon} />
				{el}
			</div>;
		}
		if (this.props.label) {
			let cls = this.props.className === undefined ? 'form-group' : this.props.className;
			if (this.props.disabled) {
				cls += ' disabled'
			}
			return (
				<div className={cls} title={this.props.title || this.props.tip || null}>
					<label htmlFor={this.props.name} className={this.props.classNameLabel || null}>
						{this.props.label}
					</label>
					{el}
					{this.renderTip()}
				</div>
			);
		}
		return (
			!this.props.tip
				? el
				: <div>{el}{this.renderTip()}</div>
		);
	}
}

export class Input extends TextComponent {
	shouldHideValue(value) {
		const hideValues = this.props.hideValues;
		if (hideValues === undefined || hideValues === null) {
			return false;
		}

		if (Array.isArray(hideValues)) {
			return hideValues.includes(value);
		}
		
		return hideValues === value;
	}

	getValue() {
		const name = this.props.mapName || this.props.name;
		const value = this.props.model && name ? this.props.model[name] : this.props.value;
		if (this.shouldHideValue(value)) {
			return '';
		}
		return value || (value === 0 ? value : '');
	}

	onChange = (e) => {
		let name = this.props.mapName || this.props.name;
		let val = e.currentTarget.value;
		const p = this.props;


		if (p.type === 'number' && val !== '') {
			const num = Number(val);
			if (!isNaN(num)) {
				if (p.min !== undefined && p.min !== null) {
					const min = Number(p.min);
					if (!isNaN(min) && num < min) {
						val = String(min);
					}
				}
				if (p.max !== undefined && p.max !== null) {
					const max = Number(p.max);
					if (!isNaN(max) && num > max) {
						val = String(max);
					}
				}
			}
		}

		if (this.props.model && name) {
			const currentValue = this.props.model[name];
			if (this.shouldHideValue(currentValue) && (val === '' || val === null || val === undefined)) {
				this.forceUpdate();
				if (this.props.onChange) {
					this.props.onChange(e);
				}
				return;
			}
			this.props.model[name] = val;
			this.forceUpdate();
		}
		if (this.props.onChange) {
			this.props.onChange(e);
		}
	}

	renderElement() {
		//let classes = this.props.label ? null : this.props.className;
		/*
		if (this.props.defStyle === undefined || this.props.defStyle === true) {
			classes = classes ? `${classes} form-control input-sm` : 'form-control input-sm';
		}
		if (this.props.required) {
			classes = classes ? `${classes} required` : 'required';
		}
		*/
		const p = this.props
		let required = p.required || (p.validations && p.validations.hasOwnProperty(p.name) && p.validations[p.name].hasOwnProperty('required'));
		let el =
			<input
				type={p.type || this.state.type || null}
				id={p.id || p.name || null}
				name={p.name || null}
				className={classNames([p.classNameEl || "form-control input-sm", required ? 'required' : null])}
				required={required}
				placeholder={p.placeholder || p.title}
				value={this.getValue()}
				onChange={this.onChange}
				onKeyDown={p.onKeyDown ?? null}
				onFocus={p.onFocus ?? null}
				onBlur={p.onBlur ?? null}
				onKeyUp={p.onKeyUp ?? null}
				style={p.style || null}
				disabled={p.disabled || false}
				readOnly={p.readOnly || false}
				min={p.min || p.min === 0 ? p.min : null}
				max={p.max || p.max === 0 ? p.max : null}
				maxLength={p.maxLength || null}
				step={p.step || (p.type == 'number' ? 'any' : null)}
				lang={p.lang || (p.type == 'number' ? 'en' : null)}
				autoFocus={p.autoFocus || null}
				autoComplete={p.autoComplete || null}
				title={p.title || null}
			/>;
		return (
			!p.classNameControl
				? el
				: <div className={p.classNameControl}>{el}{this.renderTip()}{this.props.children || null}</div>
		);
	}
}

export class InputMask extends Input {
	renderElement() {
		const p = this.props
		let required = p.required || (p.validations && p.validations.hasOwnProperty(p.name) && p.validations[p.name].hasOwnProperty('required'));
		let el =
			<ReactInputMask
				id={p.id || p.name || null}
				name={p.name || null}
				className={classNames([p.classNameEl || "form-control input-sm", required ? 'required' : null])}
				mask={p.mask}
				replacement={p.replacement || null}
				showMask={p.showMask || null}
				required={required}
				placeholder={p.placeholder || p.title}
				value={this.getValue()}
				onChange={this.onChange}
				onKeyDown={p.onKeyDown ?? null}
				onFocus={p.onFocus ?? null}
				onBlur={p.onBlur ?? null}
				onKeyUp={p.onKeyUp ?? null}
				disabled={p.disabled || false}
				readOnly={p.readOnly || false}
				maxLength={p.maxLength || null}
				step={p.step || (p.type == 'number' ? 'any' : null)}
				lang={p.lang || (p.type == 'number' ? 'en' : null)}
				autoFocus={p.autoFocus || null}
				title={p.title || null}
			/>;
		return (
			!p.classNameControl
				? el
				: <div className={p.classNameControl}>{el}{this.renderTip()}{this.props.children || null}</div>
		);
	}
}

export class InputColor extends TextComponent {
	getValue() {
		const name = this.props.mapName || this.props.name;
		const value = this.props.model && name ? this.props.model[name] : this.props.value;
		return value || '';
	}

	onChange = (e) => {
		let name = this.props.mapName || this.props.name;

		if (this.props.model && name) {
			this.props.model[name] = e.currentTarget.value;
			this.forceUpdate();
		}
		if (this.props.onChange) {
			this.props.onChange(e);
		}
	}

	onReset = () => {
		let name = this.props.mapName || this.props.name;
		const resetColor = '';

		if (this.props.model && name) {
			this.props.model[name] = resetColor;
			this.forceUpdate();
		}
		if (this.props.onChange) {
			this.props.onChange({ currentTarget: { value: resetColor } });
		}
	}

	renderElement() {
		const p = this.props;
		const currentColor = this.getValue()?.toUpperCase() || '';
		const hasColor = currentColor && /^#([0-9A-Fa-f]{6})$/.test(currentColor);

		let required = p.required || (p.validations && p.validations.hasOwnProperty(p.name) && p.validations[p.name].hasOwnProperty('required'));

		let inputColor = (
			<div className='color-picker-container'>
				{!hasColor && <div className='color-placeholder-background' />}

				<input
					type="color"
					id={p.id || p.name || null}
					name={p.name || null}
					className={classNames([p.classNameEl || "form-control input-sm input-color", required ? 'required' : null])}
					required={required}
					value={currentColor}
					onChange={this.onChange}
					onKeyDown={p.onKeyDown ?? null}
					onFocus={p.onFocus ?? null}
					onBlur={p.onBlur ?? null}
					onKeyUp={p.onKeyUp ?? null}
					style={{
						...p.style,
						opacity: hasColor ? 1 : 0,
					}}
					disabled={p.disabled || false}
					readOnly={p.readOnly || false}
					autoFocus={p.autoFocus || null}
					title={p.title || null}
				/>

				{!hasColor && (
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: '0.75em',
							color: '#666',
							pointerEvents: 'none'
						}}
					>
						{__('attrs_color_placeholder')}
					</div>
				)}
			</div>
		)

		const resetButton = !p.hideResetButton && hasColor ? (
			<em className='la la-times reset-color' onClick={this.onReset} title={__('buttons_reset')}></em>
		) : null;

		const colorLabel = p.showColorLabel && currentColor ? (
			<a className='color-value-label' title={__('attrs_copy_selected_color')} onClick={() => CopyClipboard(currentColor, `${currentColor} ${__('buttons_copy_clipboard_success')}`)}>
				<span>{currentColor}</span>
				<em className='la la-copy' />
			</a>
		) : null;

		const colorWrapper = (
			<div className="input-color-wrapper">
				{inputColor}
				{resetButton}
				{colorLabel}
			</div>
		);

		return (
			!p.classNameControl
				? colorWrapper
				: <div className={p.classNameControl}>{colorWrapper}{this.renderTip()}{this.props.children || null}</div>
		);
	}
}

export class InputFile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			file: null,
			img: null
		}
		this.ref = React.createRef()
	}

	static getFileState(file) {
		if (!file || typeof file === 'string') {
			return {
				file: null,
				img: null
			}
		}
		const is_image = file.type.match(/^image\//) != null
		return {
			file: file,
			img: is_image ? URL.createObjectURL(file) : null
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (!nextProps.hasOwnProperty('file') || nextProps.file === prevState.file) {
			return null;
		}
		return InputFile.getFileState(nextProps.file);
	}

	onChange = (e) => {
		if (e.currentTarget.files.length == 0) {
			return;
		}
		const state = InputFile.getFileState(e.currentTarget.files[0]);
		this.setState(state);
		if (this.props.model && this.props.name) {
			this.props.model[this.props.name] = e.currentTarget.files[0];
		}
		if (this.props.onChange) {
			this.props.onChange(e);
		}
	}

	componentDidUpdate() {
		const { model, name, file } = this.props
		const value = model && name ? model[name] : file

		if (!value && this.ref.current) {
			this.ref.current.value = ''
		}
	}


	onRemove = (e) => {
		e.preventDefault()
		this.setState({
			file: null,
			img: null
		});
		if (this.props.model && this.props.name) {
			this.props.model[this.props.name] = null;
		}
		if (this.props.onChange) {
			this.props.onChange(null);
		}
	}

	onEdit = (e) => {
		e.preventDefault()
		this.ref.current.click()
	}

	getRemoveButton(transparency = 'btn-transparent') {
		return (
			!this.props.hasOwnProperty('disableRemove') && (!this.props.hasOwnProperty('readOnly') || this.props.readOnly == 0)
				? <button key='x' type='button' className={classNames('btn xdel btn-circular', transparency)} onClick={this.onRemove}>
					<em className="la la-trash danger pointer" />
				</button>
				: null
		)
	}

	getEditButton(transparency = 'btn-transparent', classname = 'edt') {
		return (
			!this.props.hasOwnProperty('readOnly') || this.props.readOnly == 0
				? <button key='e' type='button' className={classNames('btn btn-circular', classname, transparency)} onClick={this.onEdit}>
					<em className="la la-pencil pointer" />
				</button>
				: null
		)
	}

	addSelectedFile = () => {
		console.log(this.state.selectedFiles);
	}

	render() {
		const { type, model, name, className, classNameImg, file, imageNone, readOnly, required, inputHidden } = this.props
		const as_image = type == 'image'
		let thumb
		let remove = null
		const value = model && name ? model[name] : file
		const id = this.props.id || 'file'
		const mandatory = required ? <div className="mandatory" /> : null;

		if (this.state.img) {
			thumb =
				<label htmlFor={id}>
					<img src={this.state.img} className={classNameImg || null} />
					<div className="flex-center">
						{this.getEditButton(null)}
						{this.getRemoveButton(null)}
					</div>
					<span className='filename'>{this.state.file.name}</span>
					{mandatory}
				</label>
		}
		else if (this.state.file) {
			thumb =
				<label htmlFor={id}>
					<em className="la la-file-alt" />
					{this.state.file.name}
				</label>
			remove = this.getRemoveButton()
		}
		else {
			const has_file = model && typeof model[name] == 'string' && model[name];
			let label;

			if (this.props.hasOwnProperty('label')) {
				label = this.props.label;
			}
			else if (has_file) {
				if (as_image) {
					label = [
						<img key='i' src={model[name]} className={classNameImg || null} />,
						<div key='b' className="btn-ungroup">
							{this.getRemoveButton()}
							{this.getEditButton()}
						</div>
					]
				}
				else {
					label = /(png|jpg|jpeg|gif|webp|bmp)/.test(model[name] || '') ? <img src={'/' + file} /> : <span className='legend-label'>{model[name]}</span>
					remove = this.getRemoveButton()
				}
			}
			else if (imageNone) {
				label = [
					<img key='i' src={imageNone} />,
					this.getEditButton(null, 'xdel')
				]
			}
			else {
				label = <span className='file-label'>{__(as_image ? 'attrs_upload_image' : 'attrs_upload_file')}</span>;
			}
			thumb =
				<label htmlFor={id} className={has_file || this.props.label ? null : "none"}>
					{label}
					{mandatory}
				</label>
			/*
			const current = this.props.model && typeof this.props.model[this.props.name] == 'string' ? this.props.model[this.props.name] : null;
			thumb =
				<label htmlFor="file" className="none">
					{this.props.label || current || __(as_image ? 'attrs_upload_image' : 'attrs_upload_file')}
				</label>
			*/
		}
		return (
			<div className={classNames(className || "file", readOnly == true ? 'readonly' : null)} title={this.props.title || null}>
				{thumb}
				<input type="file" id={id} disabled={readOnly == true} multiple={this.props.multiple || null} className={inputHidden === true ? 'hidden' : null}
					filename={value instanceof Object ? value.name : value}
					onChange={this.onChange}
					ref={this.ref}
					accept={this.props.accept || (as_image ? 'image/*' : null)}
				/>
				{remove}
				{this.props.children || null}
			</div>
		)
	}
}

export class Textarea extends TextComponent {
	state = {
		changed: false
	};

	onChange = (e) => {
		const name = this.props.mapName || this.props.name;

		this.state.changed = true;
		if (this.props.model && name) {
			this.props.model[name] = e.currentTarget.value;
			this.forceUpdate();
		}
		if (this.props.onChange) {
			this.props.onChange()
		}
	}

	onFocus = (e) => {
		this.state.changed = false;
		if (this.props.onFocus) {
			this.props.onFocus(e);
		}
	}

	onBlur = (e) => {
		if (this.props.onChanged && this.state.changed) {
			this.props.onChanged(e);
		}
		if (this.props.onBlur) {
			this.props.onBlur(e)
		}
	}

	renderElement() {
		const base_class = this.props.label ? null : (this.props.className || null)
		const classes = classNames(base_class ?? 'form-control', this.props.required ? 'required' : null)

		const el =
			<textarea
				id={this.props.id || this.props.name}
				className={classes || this.props.classNameEl || null}
				rows={this.props.rows || 4}
				value={this.props.model && this.props.name ? this.props.model[this.props.name] || '' : ''}
				onChange={this.onChange}
				onFocus={this.props.onChanged ? this.onFocus : (this.props.onFocus ?? null)}
				onBlur={this.props.onBlur || this.props.onChanged ? this.onBlur : null}
				required={this.props.required ?? null}
				minLength={this.props.minLength ?? null}
				maxLength={this.props.maxLength ?? null}
				autoFocus={this.props.autoFocus ?? null}
				disabled={this.props.disabled ?? null}
				readOnly={this.props.readOnly ?? null}
				placeholder={this.props.placeholder ?? null}
			/>;
		return (!this.props.classNameControl ? el : <div className={this.props.classNameControl}>{el}</div>);
	}
}


export class Search extends React.Component {
	constructor(props) {
		super(props);
		this.state = { value: props.initValue || '', timeout: 0 }
	}

	componentDidMount() {
		this.state.value = this.props.initValue || '';
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.timeout == 0 && nextProps.value && nextProps.value != prevState.value) {
			return { value: nextProps.value };
		}
		return null;
	}

	onClick = () => {
		if (this.props.doSearch) {
			this.props.doSearch(this.state.value);
		}
	}

	onChange = (e) => {
		const timeout = this.props.timeout === undefined ? 500 : this.props.timeout

		if (this.state.timeout > 0) {
			clearTimeout(this.state.timeout);
			this.state.timeout = 0;
		}
		const value = e.currentTarget.value;

		if (timeout > 0 && this.props.doSearch) {
			this.state.timeout = setTimeout(() => {
				this.props.doSearch(value.toLowerCase().normalize());
				this.state.timeout = 0;
			}, timeout);
		}
		this.setState({ value: value });
	}

	onClear() {
		this.setState({ value: '' });
	}

	render() {
		const { showSearchButton, showSearchIcon, name } = this.props;
		const el =
			<input name={name || null}
				type='text'
				className={this.props.className || 'prompt form-control'}
				placeholder={(this.props.placeholder || __('attrs_search')) + '...'}
				value={this.state.value}
				onChange={this.onChange}
				style={this.props.style || null}
			/>;

		if (showSearchButton || showSearchIcon || this.props.actions) {
			return (
				<div className={this.props.classNameCtnr || 'input-group input-group-sm'} style={this.props.style || null}>
					{this.props.onCheckAll
						? <span className="input-group-addon">
							<input type="checkbox" value={1} checked={this.props.checked} onChange={this.props.onCheckAll} />
						</span>
						: (
							showSearchIcon
								? <span className="input-group-addon"><em className="la la-search" /></span>
								: null
						)
					}
					{this.props.actions || null}
					{el}
					{showSearchButton
						? <span className="input-group-btn">
							<button className="btn btn-default" type="button" onClick={this.onClick}>
								<em className='la la-search' />
							</button>
						</span>
						: null
					}
					{/*this.state.value == '' || this.state.value == undefined
						? null
						: <em
							className='la la-times'
							onClick={this.onClear}
						/>
					*/}
				</div>
			);
		}
		return el;
	}
}

export class Checkbox extends React.Component {
	ref = React.createRef();

	onClick = (e) => {
		if (this.props.disabled || this.props.readOnly) {
			return;
		}
		let checked;
		const name = this.props.mapName || this.props.name;
		const { model } = this.props;

		//e.stopPropagation();
		if (model) {
			if (!this.props.bitwise) {
				model[name] = model[name] == false || model[name] == undefined ? 1 : 0;
			}
			else if ((model[name] & this.props.bitwise) == this.props.bitwise) {
				model[name] = model[name] - (model[name] & this.props.bitwise);
			}
			else {
				model[name] |= this.props.bitwise;
			}
			checked = model[name];
			if (model.onChange instanceof Function) {
				model.onChange(name, checked);
			}
		}
		else {
			checked = this.ref.current.value;
		}
		if (this.props.onChange) {
			this.props.onChange(checked, e, model);
		}
		else if (this.props.onClick) {
			this.props.onClick(e);
		}
		else {
			this.forceUpdate();
		}
	}

	render() {
		let name = this.props.mapName || this.props.name;
		let checked = this.props.model
			? (!this.props.bitwise
				? this.props.model[name] == true
				: (this.props.model[name] & this.props.bitwise) == this.props.bitwise
			)
			: this.props.checked;

		return (
			<div className={(this.props.className || null)} title={this.props.title || null}>
				<input
					type={this.props.type || "checkbox"}
					ref={this.ref}
					id={this.props.id || this.props.name}
					name={this.props.name || null}
					className='form-check-input'
					checked={checked}
					disabled={this.props.disabled || null}
					//onChange={this.props.onChange || null}
					onChange={this.onClick}
				/>
				<label htmlFor={this.props.id || this.props.name} className={classNames("ml-1 pointer", this.props.classNameLabel || null)}>{this.props.label}</label>
			</div>
		);
	}
}


export class Switch extends Checkbox {
	render() {
		const name = this.props.mapName || this.props.name;
		const checked = this.props.model
			? (!this.props.bitwise
				? this.props.model[name] == true
				: (this.props.model[name] & this.props.bitwise) == this.props.bitwise
			)
			: this.props.checked;
		const id = this.props.id || this.props.name
		const content = 
			<label className={classNames('mtoggle', this.props.className || null)} title={this.props.title || null}>
				<input
					type="checkbox"
					id={id}
					name={name}
					ref={this.ref}
					className='switch'
					checked={checked}
					onChange={this.onClick}
					disabled={this.props.disabled || null}
				/>
				<div className='mtoggle_fill' />
			</label>;

		if (this.props.required) {
			return (
				<div className='flex'>
					{content}
					<span className='required ml-1' />
				</div>
			);
		}
		return content;
	}
}

export class Toggle extends Checkbox {
	render() {
		const { className, title, label, disabled, readOnly } = this.props
		const name = this.props.mapName || this.props.name;
		const checked = this.props.model
			? (!this.props.bitwise
				? this.props.model[name] == true
				: (this.props.model[name] & this.props.bitwise) == this.props.bitwise
			)
			: this.props.checked;

		return (
			<label className={classNames('toggle', disabled || readOnly ? null : 'pointer', className || null)} title={title || null} onClick={this.onClick}>
				<em className={classNames(checked ? 'la la-toggle-on' : 'la la-toggle-off', disabled ? 'disabled' : null)} ref={this.ref} />
				{label ? <span className={disabled ? 'disabled' : null}>{label}</span> : null}
			</label>
		);
	}
}


export class Radio extends React.Component {
	onChange = (e) => {
		if (this.props.disabled) {
			return;
		}
		const { model, name, bitwise, onChange } = this.props
		const value = e.currentTarget.value

		e.stopPropagation()
		if (model) {
			if (!bitwise) {
				model[name] = value;
			}
			else if ((model[name] & bitwise) == bitwise) {
				model[name] = model[name] - (model[name] & bitwise);
			}
			else {
				model[name] |= bitwise;
			}
		}
		if (!onChange || onChange(value) === true) {
			this.forceUpdate();
		}
	}

	render() {
		const { model, name, values, className, classNameBtnDef, title, required, disabled } = this.props
		const value = model
			? (!this.props.bitwise
				? model[name]
				: (model[name] & this.props.bitwise)
			)
			: this.props.value;
		const components = [];
		const cls_def = classNameBtnDef || 'btn-default';
		const id = this.props.id || name;
		const class_radio = this.props.showRadio === false ? 'hidden' : null;

		(values || []).forEach((v, i) => {
			components.push(
				<label key={i} htmlFor={id + i} className={classNames('btn flex ', value == v.value ? 'btn-default active' : cls_def, disabled ? 'disabled' : null, v.className || null)} title={v.title || null}>
					<input key={i} type="radio" id={id + i} name={name} value={v.value} checked={value == v.value} className={class_radio} onChange={this.onChange} />
					<span className='ml-1'>{v.label}</span>
				</label>
			);
		})
		return (
			<div className="flex-center">
				<div className={classNames('btn-group btn-switch', className || null)} title={title || ''}>
					{components}
				</div>
				{required ? <span className="required" /> : null}
			</div>
		);
	}
}


export class MonthPicker extends TextComponent {
	constructor(props) {
		super(props);
		this.state = { editingValue: null };
		this.ref = React.createRef();
	}

	getValue() {
		let value = this.state.editingValue || (this.props.model ? (this.props.model[this.props.name] || '') : '');
		if (value instanceof Date) {
			value = format(value, this.props.format || 'yyyy-MM');
		}
		return value
	}

	onCalendarIconClick = (e) => {
		if (this.props.onCalendarIconClick) {
			this.props.onCalendarIconClick(e.target.value)
		}
		else {
			$('#' + this.props.name).datepicker('show');
		}
	};

	onChange = (e) => {
		let value = e.target.value;
		if (!e.target.value) {
			this.props.model[this.props.name] = null;
			value = null;
		}
		if (this.props.model) {
			this.props.model[this.props.name] = e.target.value;
		}
		this.setState({ editingValue: value });
		if (this.props.onChange) {
			this.props.onChange(e.target.value)
		}
	}

	onBlur = () => {
		if (this.state.editingValue) {
			let value = Date.parse(this.state.editingValue);
			if (!isNaN(value)) {
				this.props.model[this.props.name] = new Date(value);
			}
			if (this.props.onChange instanceof Function) {
				this.props.onChange(this.state.editingValue, value);
			}
			this.setState({ editingValue: null });
		}
	}

	componentDidMount() {
		$(this.ref.current).datepicker({
			onClose: (dateText, inst) => {
				this.state.editingValue = new Date(inst.selectedYear, inst.selectedMonth, 1);
				$('#ui-datepicker-div').removeClass('ui-calendar-only-month');
				this.onBlur();
			},
			beforeShow: (input, inst) => {
				$('#ui-datepicker-div').addClass('ui-calendar-only-month');
			},
			minDate: this.props.minDate || null,
			maxDate: this.props.maxDate || null,
			changeMonth: this.props.changeMonth || null,
			changeYear: this.props.changeYear || null,
			format: this.props.format || 'yyyy-MM',
			showOn: this.props.showOn || 'none',
			showButtonPanel: this.props.showButtonPanel || null,
		});
	}

	componentWillReceiveProps() {
		$(this.ref.current)
			.datepicker('option', 'minDate', this.props.minDate || null)
			.datepicker('option', 'maxDate', this.props.maxDate || null)
			.datepicker('option', 'changeMonth', this.props.changeMonth || null)
			.datepicker('option', 'changeYear', this.props.changeYear || null)
			.datepicker('option', 'format', this.props.format || null)
			.datepicker('option', 'showButtonPanel', this.props.showButtonPanel || null);
	}

	renderElement() {
		const el =
			<div className='input-group'>
				<input
					type="text"
					id={this.props.name || null}
					ref={this.ref}
					className={classNames(["form-control input-sm", this.props.classNameEl, this.props.required ? 'required' : null])}
					value={this.getValue()}
					onChange={this.onChange}
					onBlur={this.onBlur}
					placeholder={this.props.placeholder || null}
					disabled={this.props.disabled || null}
					required={this.props.required || null}
					autoComplete={this.props.autoComplete || null}
				/>
				<span className="input-group-addon last input-sm" onClick={this.onCalendarIconClick}><em className="la la-calendar"></em></span>
			</div>;
		return (!this.props.classNameControl ? el : <div className={this.props.classNameControl}>{el}</div>);
	}
}

export class DatePicker extends TextComponent {
	constructor(props) {
		super(props);
		this.state = { editingValue: null };
		this.ref = React.createRef();
	}

	getValue() {
		const value = this.props.value || (this.props.model ? this.props.model[this.props.name] : null);
		return !value || value instanceof Date ? value : new Date(value);
	}

	onChange = (e) => {
		this.setState({ editingValue: e.target.value });
		if (this.props.onChange) {
			this.props.onChange(e.target.value)
		}
	}

	onBlur = () => {
		if (this.state.editingValue) {
			const value = Date.parse(this.state.editingValue);

			if (!isNaN(value)) {
				this.props.model[this.props.name] = new Date(value);
			}
			if (this.props.onChange instanceof Function) {
				this.props.onChange(this.state.editingValue, value);
			}
			this.setState({ editingValue: null });
		}
	}

	/*
	componentDidMount() {
		$(this.ref.current).datepickr({
			onSelect: value => {
				this.state.editingValue = value;
				this.onBlur();
			},
			minDate: this.props.minDate || null,
			maxDate: this.props.maxDate || nu\ll
		});
	}

	componentWillReceiveProps(props) {
		$(this.ref.current)
			.datepickr('option', 'minDate', props.minDate || null)
			.datepickr('option', 'maxDate', props.maxDate || null);
	}
	*/

	renderElement() {
		let value = this.state.editingValue || (this.props.model ? (this.props.model[this.props.name] || '') : '');

		if (value instanceof Date) {
			value = format(value, 'yyyy-MM-dd');
		}
		const el =
			<input
				type="date"
				id={this.props.name || null}
				ref={this.ref}
				className={classNames(["form-control input-sm", this.props.classNameEl, this.props.required ? 'required' : null])}
				value={value}
				onChange={this.onChange}
				onBlur={this.onBlur}
				placeholder={this.props.placeholder || null}
				disabled={this.props.disabled || null}
				required={this.props.required || null}
				autoComplete={this.props.autoComplete || null}
				min={this.props.minDate || null}
				max={this.props.maxDate || null}
			/>;
		return (!this.props.classNameControl ? el : <div className={this.props.classNameControl}>{el}</div>);
	}
}

export class DateTimePicker extends Input {
	constructor(props) {
		super(props);
		this.state.type = props && props.type ? props.type : "datetime-local";
	}
	/*
	componentDidMount() {
		$(this.ref.current).datetimepicker({
			onSelect: value => {
				this.state.editingValue = value;
				this.onBlur();
			},
			autoclose: true,
			format: 'Y-m-d H:i',
			minDate: this.props.minDate || null,
			maxDate: this.props.maxDate || null
		});
	}

	componentWillReceiveProps(props) {
		$(this.ref.current)
			.datetimepicker('option', 'minDate', props.minDate || null)
			.datetimepicker('option', 'maxDate', props.maxDate || null);
	}
	*/
}


export class Select extends TextComponent {
	constructor(props) {
		super(props);
		this.state = {
			inputValue: null,
			selectedOption: null
		};
		this.timeout = 0;
		this.inputText = null
	}

	static getSelectedOption(props, state) {
		const options = props.options || state.defaultOptions || [];
		const has_model_name = props.model && props.name
		const value = has_model_name ? props.model[props.name] : props.value;

		if (state.selectedOption && state.selectedOption == value) {
			return state.selectedOption;
		}
		if (value === null || value === undefined || options.length == 0) {
			return null;
		}
		if (Array.isArray(value)) {
			const id = options.length > 0 && options[0].hasOwnProperty('id') ? 'id' : 'value';
			const selection = [];
			let k;
			for (let i = 0, l = value.length; i < l; i++) {
				let v = value[i];
				if ((k = options.findIndex(e => e[id] == v)) >= 0) {
					selection.push(options[k]);
				}
			}
			return selection;
		}
		if (options.length == 0) {
			return null
		}
		if (has_model_name && options[0].hasOwnProperty(props.name) && (props.useNameAsValue === undefined || props.useNameAsValue == true)) {
			return options.find(e => e[props.name] == value);
		}
		return options.find(e => e.value == value);
	}

	static getDerivedStateFromProps(props, state) {
		const selected = Select.getSelectedOption(props, state)
		if (selected) {
			return { selectedOption: selected }
		}
		return null
	}

	onInputChange = (text) => {
		if (text) {
			this.inputText = text
		}
	}

	onChange = (_selectedOption) => {
		let selectedOption = _selectedOption || [];
		const { model, name, onChange, isMulti, optionValue } = this.props

		if (model) {
			if (!isMulti) {
				const id = optionValue || (
					selectedOption.hasOwnProperty(name) && (this.props.useNameAsValue === undefined || this.props.useNameAsValue == true)
						? name
						: selectedOption.hasOwnProperty('id') ? 'id' : 'value'
				);
				model[name] = selectedOption[id] || selectedOption[id] === 0 ? selectedOption[id] : null;
			}
			else if (selectedOption.length == 0) {
				model[name] = null;
			}
			else {
				const id = selectedOption[0].hasOwnProperty('id') ? 'id' : 'value';
				model[name] = selectedOption.reduce((selection, current) => {
					selection.push(current[id])
					return selection
				}, []);
			}
		}
		if (onChange instanceof Function) {
			selectedOption.inputText = this.inputText
			onChange(selectedOption);
		}

		if (_selectedOption === null) {
			selectedOption = [];
		}

		this.setState({ selectedOption });
	}

	onInputChange(inputValue) {
		this.setState({ inputValue });
		return inputValue;
	}

	loadOptions = (inputValue, callback) => {
		if (this.timeout > 0) {
			clearTimeout(this.timeout);
			this.timeout = 0;
		}
		if (!inputValue) {
			return callback([]);
		}
		this.timeout = setTimeout(() => {
			http.get(this.props.url, { data: { term: inputValue } }, (response) => {
				const results = response.results || response
				// mantem a select com os ultimos resultados pesquisados
				this.setState({ defaultOptions: results });
				callback(results);
			});
			this.timeout = 0;
		}, 500);
	}

	noOptionsMessage = (props) => {
		if (this.state.inputValue === null || this.state.inputValue === '') {
			return (
				<span {...props.innerProps} align="center" variant="title">
					{__('attrs_search')}...
				</span>
			);
		}
		return (
			<span {...props.innerProps} align="center" variant="title">
				reveja a sua pesquisa
			</span>
		);
	}

	getOptionValue = (el) => this.props.optionValue ? el[this.props.optionValue] : (el.value || el.id)
	getOptionLabel = (el) => this.props.optionLabel ? el[this.props.optionLabel] : (el.label || el.text || el.value)
	getStyle = (base) => ({ ...base, zIndex: 1999 })

	getAssyncSelectObs = () => {
		const optionLabel = this.props.optionLabel ?? 'label';
		return {
			value: null,
			[optionLabel]: __('attrs_async_select_obs'),
			isDisabled: true
		}
	}

	getDefaultOptions = () => {
		const options = this.state.defaultOptions || this.props.options || [];

		if (this.props.hideObs) {
			return options;
		}
		return [this.getAssyncSelectObs(), ...options];
	}

	renderElement() {
		const p = this.props
		const options = p.options || [];
		const el = !p.url
			? <ReactSelect.default
				id={p.id || null}
				placeholder={p.placeholder || __('attrs_pick_option')}
				value={this.state.selectedOption}
				options={options}
				onChange={this.onChange}
				onInputChange={this.onInputChange}
				isDisabled={p.disabled || null}
				required={p.required || null}
				isMulti={p.isMulti || null}
				noOptionsMessage={this.noOptionsMessage}
				getOptionValue={this.getOptionValue}
				getOptionLabel={this.getOptionLabel}
				className={`rselect ${p.classNameSelect || ''}${p.required ? ' required' : ''}`}
				classNamePrefix='rselect'
				isClearable={p.isClearable ?? !p.required}
				menuPortalTarget={document.body}
				autoFocus={p.autoFocus ?? false}
				styles={{ menuPortal: this.getStyle }}
			/>
			: <AsyncSelect
				id={p.id || null}
				placeholder={p.placeholder || __('attrs_pick_option')}
				cacheOptions={p.cacheOptions || false}
				defaultOptions={this.getDefaultOptions()}
				value={this.state.selectedOption}
				loadOptions={this.loadOptions}
				onChange={this.onChange}
				onInputChange={this.onInputChange}
				isDisabled={p.disabled || null}
				required={p.required || null}
				isMulti={p.isMulti || null}
				noOptionsMessage={this.noOptionsMessage}
				getOptionValue={this.getOptionValue}
				getOptionLabel={this.getOptionLabel}
				isClearable={p.isClearable ?? p.required}
				className={`rselect ${p.classNameSelect || ''}${p.required ? ' required' : ''}`}
				classNamePrefix='rselect'
				loadingMessage={() => <span className='la la-ellipsis-h' />}
				menuPortalTarget={document.body}
				autoFocus={p.autoFocus ?? false}
				styles={{ menuPortal: this.getStyle }}
			/>
		return (!p.classNameControl ? el : <div className={p.classNameControl}>{el}</div>);
	}
}


/**
 * devolve um object com propriedades por defeito do botão @name
 * @param name nome do button
 */
const defModalButton = name => {
	if (!hp._defModalButtons) {
		hp._defModalButtons = {
			close: { text: __('buttons_close'), icon: 'close', close: 'before' },
			cancel: { text: __('buttons_cancel'), icon: 'remove' },
			remove: { text: __('buttons_delete'), icon: 'trash', type: 'danger' },
			save: { label: __('buttons_save'), icon: 'check', type: 'primary' },
			confirm: { icon: 'check', type: 'primary' }
		}
	}
	return hp._defModalButtons[name];
}

export class Modal extends React.Component {
	constructor(props) {
		super(props);
		this.state = { buttons: [] };
		this.ref = React.createRef();
		this.setButtons(props ? props.buttons : null);
	}

	onClose = () => {
		if (this.props.onClose instanceof Function && this.props.onClose() === false) {
			return;
		}
		$(this.ref.current).modal('hide');
		if (this.props.onDispose instanceof Function) {
			this.props.onDispose();
		}
	}

	onClick(callback, close) {
		if (close === 'before') {
			this.onClose();
		}
		const result = callback(this.onClose);
		if (close === 'after' && (typeof result === 'undefined' || result)) {
			this.onClose();
		}
	}

	componentDidMount() {
		const modal = $(this.ref.current).modal({
			duration: 100,
			backdrop: this.props.backdrop === undefined ? true : this.props.backdrop,
			keyboard: this.props.exitOnEsc === undefined ? true : this.props.exitOnEsc
		});
		modal.modal('show').on('hidden.bs.modal', () => {
			this.onClose();
		});
	}

	setButtons(buttons_def) {
		const left = [];
		const right = [];

		(buttons_def || [{ name: 'close' }]).forEach((btn, i) => {
			if (btn.constructor === String) {
				btn = Object.assign({}, defModalButton(btn));
			}
			else if (btn.name) {
				btn = Object.assign({}, defModalButton(btn.name), btn);
			}
			const b = btn.tag
				? React.createElement(btn.tag, Object.assign({ key: i }, btn.props || {}), btn.children || null)
				: <button
					key={i}
					className={classNames('btn btn-' + (btn.type || 'default btn-light'), btn.className || null)}
					style={btn.style || null}
					title={btn.title || null}
					onClick={() => {
						if (btn.onClick instanceof Function) {
							this.onClick.call(this, btn.onClick, btn.close || null);
						}
						else {
							this.onClose();
						}
					}}
					disabled={btn.disabled || null}
				>
					{btn.icon ? <em className={"la la-" + btn.icon} /> : null} {btn.text}
				</button>;
			btn.align == 'left' ? left.push(b) : right.push(b);
		});
		this.state.buttons = [
			<div key='l' className="btn-group btn-group-sm mr-auto pull-left">{left}</div>,
			<div key='r' className="btn-group btn-group-sm">{right}</div>
		];
	}

	renderButtons() {
		return this.state.buttons;
	}

	componentWillReceiveProps(props) {
		this.setButtons(props ? props.buttons : null);
		$(this.ref.current).modal('show');
	}

	componentWillUnmount() {
		$(this.ref.current).modal('hide');
	}

	onStateChanged = (e) => {
		this.setButtons(this.props.buttons);
		this.forceUpdate();
	}

	renderChildren() {
		if (this.props.children instanceof Object) {
			return React.cloneElement(this.props.children, { buttons: this.props.buttons, onStateChanged: this.onStateChanged });
		}
		return this.props.children;
	}

	render() {
		const { className, title, actions } = this.props;

		return (
			<div className='modal' ref={this.ref} role='dialog'>
				<div className={"modal-dialog " + (className || '')}>
					<div className="modal-content">
						<div className='modal-header react'>
							<h3 className="modal-title">{title || this.state.title}</h3>
							<div className="close" onClick={this.onClose}><em className="la la-close la-min" /></div>
							<div className="clearfix" />
						</div>
						<div className='modal-body react'>
							{this.renderChildren()}
						</div>
						<div className='modal-footer justify-content-between'>
							{actions || this.renderButtons()}
						</div>
					</div>
				</div>
			</div>
		);
	}

	static show(children, params = {}) {
		mbox.modal(children, params);
	}
}
window.mbox = {
	refs: [], // contem as divs que servem de suporte às modals. o numero de refs representa a quantidade de modals abertas no mesmo instante

	modal: (children, params = {}) => {
		const el = document.createElement('div');
		const parent = params.parent ? document.getElementById(params.parent) : document.body;
		const root = createRoot(parent.appendChild(el))

		mbox.refs.push({ el, root });

		root.render(
			<Modal
				{...params}
				onClose={() => params.onClose != null ? params.onClose() : true}
				onDispose={() => { mbox.dismiss(el) }}
			>
				{children}
			</Modal>
		);
	},

	show: (message, title, icon, buttons = undefined, onClose = null, params = null) => {
		if (typeof message === "string") {
			message = <div dangerouslySetInnerHTML={{ __html: message }} />
		}
		mbox.modal(
			<table className='wide'>
				<tbody>
					<tr>
						<td style={{ padding: '10px 20px', width: '50px' }} valign='top'>
							<em className={'las la-' + icon + ' la-5x'} />
						</td>
						<td>{message}</td>
					</tr>
				</tbody>
			</table>,
			{
				title: title,
				buttons: buttons,
				onClose: onClose,
				...params
			}
		)
	},

	dismiss: (ref = null) => {
		if (!ref) {
			if (mbox.refs.length == 0) {
				return;
			}
			ref = mbox.refs.pop();
		}
		else {
			const i = mbox.refs.findIndex(r => r.el == ref);
			if (i < 0) {
				return;
			}
			ref = mbox.refs[i];
			mbox.refs.splice(i, 1);
		}
		ref.root.unmount(ref.el);
		if (ref.el.parentElement && ref.el.parentElement.isConnected) {
			ref.el.parentElement.removeChild(ref.el);
		}
	},

	confirm: (callback, message, title, buttons) => {
		mbox.show(
			message,
			title || __('buttons_confirm'),
			'question-circle', buttons || [
				{ type: 'primary', icon: 'check', title: __('buttons_confirm'), onClick: callback },
				'cancel'
			]
		)
	},

	confirmDelete: (callback, message, title, id, obs) => {
		mbox.show(
			obs || (typeof message === 'string' ? __('attrs_delete_item_confirm', { id: message || id }) : message),
			title || (__('attrs_delete') + (id ? (' [' + id + ']') : '')),
			'question-circle', [
			{ name: 'remove', onClick: callback },
			'cancel'
		]
		)
	},

	info: (message, title, onClose = null) => {
		mbox.show(message, title || __('attrs_info'), 'info-circle', [{ type: 'transparent', icon: 'la la-check' }], onClose);
	},

	error: (message, title, onClose = null) => {
		mbox.show(message, title || __('attrs_error'), 'exclamation-circle red', [], onClose);
	}
}
mbox.ask = mbox.confirm;


export class Tabs extends React.Component {
	constructor(props) {
		super(props)
		this.state = {}
		this.loaded = {} // memoriza os tabs que já foram carregados
	}

	static getDerivedStateFromProps = (props, state) => (
		props.activeTab !== undefined
			? {
				prevTab: props.activeTab,
				activeTab: state.prevTab != props.activeTab ? props.activeTab : state.activeTab
			}
			: null
	)

	children() {
		if (this.props.children instanceof Array) {
			return this.props.children.filter(tab => tab != null);
		}
		return this.props.children instanceof Object ? [this.props.children] : [];
	}

	onTabChanged = (e) => {
		const name = e.currentTarget.name

		if (name) {
			this.loaded[name] = 1
		}
		this.setState({ activeTab: name });
		if (this.props.onTabChanged instanceof Function) {
			this.props.onTabChanged(name);
		}
	}

	onTabKeyDown = (e) => {
		const key = e.key !== undefined ? e.key : e.keyCode

		if (key === 13 || key === 32 || key === 'Enter' || key === ' ') {
			e.preventDefault()
			this.onTabChanged(e)
		}
	}

	render() {
		const { activeTab } = this.state
		const children = this.children()
		let selected_tab = activeTab ? children.find(tab => activeTab === tab.props.name) : null

		if ((selected_tab = selected_tab || (children.length > 0 ? children[0] : null)) != null) {
			this.loaded[selected_tab.props.name] = 1
		}
		const tabs = children.map((tab, i) =>
			<li
				key={i}
				className={classNames(
					tab === selected_tab ? 'active' : null,
					tab.props.disabled ? 'disabled' : null
				)}
				title={tab.props.title || null}
			>
				<a role="tab" tabIndex={0} name={tab.props.name} onClick={tab.props.disabled ? null : this.onTabChanged} onKeyDown={this.onTabKeyDown}>
					{tab.props.icon ? <em className={tab.props.icon} /> : null}
					<span className={tab.props.classNameLabel || null}>{tab.props.label || tab.props.title || null}</span>
				</a>
			</li>
		)
		const tabContent = children.map((tab, i) =>
			selected_tab === tab
				? <div key={i} className='tab-pane fade in active'>{tab}</div>
				: <div key={i} className='tab-pane fade'>{this.loaded[tab.props.name] == 1 ? tab : null}</div>
		);
		return (
			<div>
				<div>
					<ul className={this.props.className || "nav nav-tabs"}>
						{tabs}
					</ul>
				</div>
				<div className="tab-content">
					{tabContent}
				</div>
			</div>
		);
	}
}

export class Tab extends React.Component {
	render() {
		if (this.props.children instanceof Array) {
			return (<div>{this.props.children}</div>);
		}
		return (this.props.children || <noscript />);
	}
}


export class Dropdown extends React.Component {
	constructor(props) {
		super(props)
		const value = props.model && props.name ? props.model[props.name] : null
		const item = props.items && value != null
			? props.items.find(item => item.value == value)
			: null
		this.state = { selected: item }
	}

	onChange = (e) => {
		const { model, name } = this.props
		const item = this.props.items[e.currentTarget.value]

		if (model && name) {
			model[name] = item.value
		}
		let success = true;

		if (this.props.onChange) {
			success = this.props.onChange(item)
		}
		if (success !== false) {
			this.setState({ selected: item });
		}
	}

	render() {
		const { items, className, classNameBtn, classNameUl, renderItem, children, caret, title } = this.props
		const { selected } = this.state
		const cls = classNames('dropdown-toggle', classNameBtn === undefined ? 'btn btn-default' : classNameBtn)
		const _items = items
			? items.map((item, i) =>
				<li key={i} value={i} onClick={this.onChange} className={item == selected ? 'active' : null}>
					{renderItem
						? renderItem(item)
						: <a role='button' tabIndex={0}>{this.props.itemLabel ? item[this.props.itemLabel] : (item.label || item.text)}</a>
					}
				</li>
			)
			: children;
		const label = selected ? (selected.label || selected.text) : (this.props.label || null);

		return (
			<div className={classNames("btn-group", className || null)} title={title || null}>
				<button className={cls} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					{this.props.icon ? <em className={this.props.icon} /> : null}
					{(label || caret !== false) && <span>{label || null}</span>}
					{caret !== false && <span className="caret" />}
				</button>
				<ul className={classNames("dropdown-menu", classNameUl || className || null)}>
					{_items}
				</ul>
			</div>
		);
	}
}

export const CopyClipboard = (text, message = null) => {
	navigator.clipboard.writeText(text);
	notifications.set([{ msg: message || __('buttons_copy_clipboard_success') }])
}


export class ButtonTaskUpdate extends React.Component {
	render() {
		const { className } = this.props

		return (
			<button className={className || "btn btn-default"} title={`(${hp.store.update.date}). ${__('buttons_update_tip')}`} onClick={this.props.onClick}>
				<em className="la la-sync" />
				<span>{__('attrs_updated_at')}: </span>
				<span>{hp.store.update.hour} </span>
			</button>
		)
	}
}
